import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { CircleAlertIcon } from "Components/Icons/CircleAlertIcon";

interface StyledModalProps {
    isOpen: boolean;
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
    confirmButtonLabel: string;
    cancelButtonLabel?: string
    icon?: React.ReactNode
    disabledSubmit?: boolean;
    onClose: () => void;
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    isLoading?: boolean;
}

export class StyledModal extends React.Component<StyledModalProps> {
    render() {
        return (
            <Modal
                className="styledModal"
                show={this.props.isOpen}
                onHide={this.props.onClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form onSubmit={this.props.onSubmit}>
                    <ModalHeader className="headerModal">
                        <i className={"icon icon-close"} onClick={this.props.onClose} />
                        <div className="headerContainer">
                            <div className="title-container">
                                {this.props.icon ?
                                    (<div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                        {this.props.icon}
                                    </div>)
                                    : <CircleAlertIcon className="alertIcon" />}
                                <h1>
                                    {this.props.title}
                                </h1>
                            </div>
                            <h3>
                                {this.props.subtitle}
                            </h3>
                        </div>
                    </ModalHeader>
                    <ModalBody className="bodyModal">
                        {this.props.children}
                    </ModalBody>
                    <ModalFooter className="footerModal">
                        <Button
                            type={"submit"}
                            className="confirmButton"
                            disabled={(this.props.disabledSubmit || this.props.isLoading) ?? false}
                            >
                            {this.props.isLoading && <Spinner size="sm" className="buttonSpinner"/>}
                            {this.props.isLoading ? "Loading..." : this.props.confirmButtonLabel}
                        </Button>
                        {this.props.cancelButtonLabel &&
                             <Button
                                onClick={this.props.onClose}
                                className="cancelButton">{this.props.cancelButtonLabel}
                            </Button>
                        }
                    </ModalFooter>
                </Form>
            </Modal>);
    }
}